import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import BlockIcon from "@mui/icons-material/Block";
import {
  AuditorStatusType,
  AuditorStatusTypeLabel,
  AdminStatusType,
  AdminStatusTypeLabel,
} from "../../../../utils/enums";


export const getStatusChipProps = (statusKey, theme) => {
  if (!statusKey) return null;

  // Admin statuses
  const isReadyForAudit = statusKey === AdminStatusType.READY_FOR_AUDIT;
  const isNotReady = statusKey === AdminStatusType.NOT_READY;

  // Auditor statuses
  const isApproved = statusKey === AuditorStatusType.APPROVED;
  const isRedFlagged = statusKey === AuditorStatusType.RED_FLAGGED;
  const isNotApplicable = statusKey === AuditorStatusType.MARK_AS_NOT_APPLICABLE;

  // Determine label
  let label = "Status";
  if (isReadyForAudit || isNotReady) {
    label = AdminStatusTypeLabel[statusKey];
  } else if (isApproved || isRedFlagged || isNotApplicable) {
    label = AuditorStatusTypeLabel[statusKey];
  }

  // Determine icon
  let icon = null;
  if (isReadyForAudit || isApproved) {
    icon = <CheckCircleOutlineIcon fontSize="small" />;
  } else if (isRedFlagged) {
    icon = <ErrorOutlineIcon fontSize="small" />;
  } else if (isNotApplicable) {
    icon = <BlockIcon fontSize="small" />;
  }

  // Determine colors
  let backgroundColor, color, iconColor;
  if (isReadyForAudit || isApproved) {
    backgroundColor = theme.customColors.status.success.bg;
    color = theme.customColors.status.success.text;
    iconColor = theme.customColors.status.success.text;
  } else if (isRedFlagged) {
    backgroundColor = theme.customColors.status.error.bg;
    color = theme.customColors.status.error.text;
    iconColor = theme.customColors.status.error.text;
  } else if (isNotApplicable) {
    backgroundColor = theme.customColors.status.warning.bg;
    color = theme.customColors.status.warning.text;
    iconColor = theme.customColors.status.warning.text;
  } else if (isNotReady) {
    backgroundColor = theme.customColors.background.light;
    color = theme.customColors.text.secondary;
    iconColor = theme.customColors.text.secondary;
  }

  return {
    label,
    icon,
    backgroundColor,
    color,
    iconColor,
  };
};
